<template>
  <div v-if="currentSubscription && newSubscription" data-test-hook="upgrade-to-multi-home-modal">
    <b-row class="mb-3 text-center" no-gutters v-if="isEnrollment">
      <h5 class="mx-auto header">{{ $t('xToReceivePremiumFeaturesYouMustUpgrade') }}</h5>
      <p class="upgrade-desc">
        {{
          $t('xWeWillApplyAProratedCredit', {
            0: getCurrencyString(newSubscription.cost),
            1: $moment(currentSubscription.renewalDate).format($t('xShortDate'))
          })
        }}
      </p>
    </b-row>
    <b-row class="mb-3 text-center" no-gutters v-if="!isEnrollment">
      <h5 class="mx-auto header">{{ $t('xCurrentPlanNeedsToBeUpgraded') }}</h5>
      <p class="upgrade-desc">
        {{
          $t('xWeWillProrateYourPaymentText', {
            price: getCurrencyString(newSubscription.cost),
            expirationDate: $moment(currentSubscription.renewalDate).format($t('xShortDate'))
          })
        }}
      </p>
    </b-row>
    <b-row no-gutters>
      <b-col cols="6">
        <SubscriptionCard
          :subscription-product="currentSubscription.product"
          :existing-apparatuses="currentApparatuses"
          :apparatuses-to-add="newApparatuses"
          :is-new-plan="false"
        />
      </b-col>
      <b-col cols="6">
        <SubscriptionCard
          :subscription-product="newSubscription"
          :existing-apparatuses="currentApparatuses"
          :apparatuses-to-add="newApparatuses"
          :is-new-plan="true"
          :is-highlighted="true"
        />
      </b-col>
    </b-row>
    <b-row no-gutters class="mt-3">
      <b-col cols="12">
        <b-button
          variant="warning"
          class="w-100"
          :disabled="isCreatingPurchaseIntent"
          @click="$emit('openPayment')"
          data-test-hook="upgrade-to-multi-home-modal-button-continue"
        >
          {{ $t('xUpgradeNow') }}
          <b-spinner class="ml-2" v-if="isCreatingPurchaseIntent" />
        </b-button>
      </b-col>
      <b-row class="mt-3" v-if="!isEnrollment">
        <b-col class="text-center">
          <p class="text-small legal-text">*{{ $t('xPushNotificationsAreAvailableWithInstallation') }}</p>
        </b-col>
      </b-row>
    </b-row>
  </div>
</template>

<script>
import SubscriptionCard from './Common/SubscriptionCard.vue'

/**
 * This modal is only for Enrollment flows.
 */
export default {
  props: [
    'currentSubscription',
    'newSubscription',
    'apparatusList',
    'newApparatuses',
    'isCreatingPurchaseIntent',
    'isEnrollment'
  ],
  emits: ['openPayment'],
  components: {
    SubscriptionCard
  },
  data() {
    return {
      currentApparatuses: []
    }
  },
  mounted() {
    if (this.apparatusList && this.currentSubscription?.apparatuses) {
      this.currentApparatuses = this.currentSubscription.apparatuses.map(subApp => {
        return this.apparatusList.find(app => app.apparatusId === subApp.apparatusId)
      })
    }
  }
}
</script>
<style lang="scss">
.upgrade-desc {
  line-height: 1.4rem;
  margin-bottom: 0;
  font-size: 0.875rem;
}

.header {
  font-size: large;
  font-weight: 550;
}
</style>
